{
  "FundraisingJourneyMilestone": [
    "FundraisingJourneyReviewMilestone",
    "FundraisingJourneyActionMilestone"
  ],
  "IFont": ["FileFont", "Font", "WebFont"],
  "InvestorContactHistoryEntry": [
    "InvestorContactNoteEntry",
    "InvestorContactStatusEntry"
  ],
  "IPresentationDocument": ["Presentation", "Template"],
  "SurveyMilestone": [
    "SurveyDocumentMilestone",
    "SurveyPresentationMilestone",
    "SurveyInvestorFinderMilestone"
  ],
  "SurveyQuestionHelp": ["SurveyHtmlQuestionHelp", "SurveyVideoQuestionHelp"]
}
